import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, ViewEncapsulation } from '@angular/core';
import { EntityStatus } from '@shared/models/menu.model';
import { ChevronDirection } from '@app/myWeeklyLifeActs/myLifeActsMenu/lifeActMenuItem/lifeActsMenuItem.component';
import { IsMenuItemSelectedPipe } from '@app/myWeeklyLifeActs/myLifeActsMenu/isMenuItemSelected.pipe';
import { ComponentChanges } from '@app/utils/simpleChangesType';

export interface LifeActMenuModule {
  title: string;
  statusLifeActStep: EntityStatus;
  isDisabled: boolean;
  fullUrlLifeActStep: string;
}

export interface LifeActMenuLevel {
  id: number;
  title: string;
  fullUrl: string;
  status: EntityStatus;
  isDisabled: boolean;
  modules: LifeActMenuModule[];
  isExpanded?: boolean;
}

export const isLifeActMenuLevel = (menuItem: LifeActMenuLevel | LifeActMenuModule): menuItem is LifeActMenuLevel => {
  return Array.isArray((menuItem as LifeActMenuLevel).modules);
};

@Component({
  selector: 'pl-my-life-acts-menu',
  templateUrl: './myLifeActsMenu.component.html',
  styleUrls: [`./myLifeActsMenu.component.scss`],
  encapsulation: ViewEncapsulation.None,
})
export class MyLifeActsMenuComponent implements OnChanges {
  @Input({ required: true }) public menu!: LifeActMenuLevel[];
  @Input({ required: true }) public currentlySelectedLifeactStepFullUrl!: string | undefined;

  @Output() public moduleClicked: EventEmitter<string> = new EventEmitter<string>();

  protected readonly ChevronDirection: typeof ChevronDirection = ChevronDirection;

  @HostBinding('class') public classes: string = 'block';

  constructor(private isMenuItemSelectedPipe: IsMenuItemSelectedPipe) {}

  public ngOnChanges(changes: ComponentChanges<MyLifeActsMenuComponent>): void {
    if (changes.currentlySelectedLifeactStepFullUrl && !!changes.currentlySelectedLifeactStepFullUrl.currentValue) {
      this.expandLevelOfCurrentlySelectedMenuItemFullUrl(changes.currentlySelectedLifeactStepFullUrl.currentValue);
    }
  }

  public onLevelClicked(levelClicked: LifeActMenuLevel): void {
    for (const level of this.menu) {
      if (level.id === levelClicked.id) {
        level.isExpanded = !level.isExpanded;
      } else {
        level.isExpanded = false;
      }
    }
  }

  public onModuleClicked(module: LifeActMenuModule): void {
    this.moduleClicked.emit(module.fullUrlLifeActStep);
  }

  private expandLevelOfCurrentlySelectedMenuItemFullUrl(currentlySelectedMenuItemFullUrl: string): void {
    for (const level of this.menu) {
      level.isExpanded = this.isMenuItemSelectedPipe.transform(level, currentlySelectedMenuItemFullUrl);
    }
  }
}
